.googleButton {
  height: 40px; /* Fixed height to prevent layout shift. Corresponds to current 'large' button size */
  overflow: hidden;
  width: 100%;
}
